import React from 'react';
import { FaTimes } from 'react-icons/fa';
import trashIcon from '../../assets/trash.svg';
import { useI18n } from '../../i18n';
import '../Projects/DeleteProjectModal.css';

const DeleteNoteModal = ({ isOpen, onClose, onConfirm, note, loading = false }) => {
    const { t } = useI18n();
    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget && !loading) {
            onClose();
        }
    };

    const handleConfirm = () => {
        if (!loading && onConfirm) {
            onConfirm();
        }
    };

    return (
        <div className="delete-project-modal-overlay" onClick={handleBackdropClick}>
            <div className="delete-project-modal">
                <button
                    className="delete-project-modal-close"
                    onClick={onClose}
                    disabled={loading}
                    aria-label={t('common.actions.close')}
                >
                    <FaTimes size={9.33} />
                </button>

                <div className="delete-project-modal-header">
                    <div className="delete-project-modal-header-left">
                        <img
                            className="delete-project-modal-small-icon"
                            src={trashIcon}
                            alt={t('common.actions.delete')}
                        />
                        <h2 className="delete-project-modal-title">
                            {t('pages.file_manager.notes.delete_title')}
                        </h2>
                    </div>
                </div>

                <p className="delete-project-modal-description">
                    {t('pages.file_manager.notes.delete_confirm')}
                </p>

                <div className="delete-project-modal-actions">
                    <button
                        className="delete-project-modal-cancel"
                        onClick={onClose}
                        disabled={loading}
                    >
                        {t('common.actions.cancel')}
                    </button>
                    <button
                        className="delete-project-modal-delete"
                        onClick={handleConfirm}
                        disabled={loading}
                    >
                        {loading ? t('common.status.deleting') : t('common.actions.delete')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteNoteModal;
